import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from './Navbar';
// import Footer from './Footer';

const Layout = ({ children }) => {
    const location = useLocation();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    // Routes where we don't want Navbar/Footer
    const noLayoutRoutes = ['/login', '/accept-invitation', "/track"];

    const showLayout = !noLayoutRoutes.some(route =>
        location.pathname.includes(route)
    );

    return (
        <div className="min-h-screen bg-gray-50 dark:bg-zinc-950">
            {showLayout && (
                <Navbar
                    isSidebarOpen={isSidebarOpen}
                    setIsSidebarOpen={setIsSidebarOpen}
                />
            )}
            <main
                className={`min-h-screen transition-all duration-300 ease-in-out ${showLayout
                    ? isSidebarOpen
                        ? 'ml-64 p-4'
                        : 'ml-20 p-4'
                    : 'ml-0'
                    }`}
            >
                {location.pathname.includes("/login") ?
                    children
                    :
                    <div className="flex flex-col min-h-full">
                        <div className={`w-full mx-auto sm:px-2 py-2 ${(location?.pathname?.includes("/track")) && "sm:px-0 py-0"}`}>
                            <div className={`bg-white dark:bg-zinc-800 rounded-xl shadow-lg sm:px-8 px-4 py-8 space-y-8 ${(location?.pathname?.includes("/track")) && "sm:px-0 px-0 py-0 sm:py-0 space-y-0"}`}>
                                {children}
                            </div>
                        </div>
                    </div>
                }

            </main>
            {/* {showLayout && <Footer />} */}
        </div>
    );
};

export default Layout;